module.exports = {"providers":[],"isHerokuEnabled":true,"isProd":false};